module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1n3n6n-541f21e4daa62d1dbfe59029a03a5c22.svg";